import styled from 'styled-components';

const ModalWrapper = styled.div`
  position: absolute;
  z-index: 3000;
`;

export { ModalWrapper };
